module.exports = __webpack_public_path__ + "static/img/qdhf1.843015b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qdhf1.jpg
// module id = cUkY
// module chunks = 0